module.exports = __webpack_public_path__ + "static/img/logo.4f019b2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.svg
// module id = AqYs
// module chunks = 1